import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { QuestionWrapper } from 'Stories/components/Form/styles';
import { Typography, Button } from '@mui/material';
import { StyledIntro } from './introStyles';

const Intro = ({ name, onChange, text, options }) => {
  const intl = useIntl();

  const handleContinue = () => {
    // Just move to the next question without updating any answer
    onChange('');
  };

  return (
    <StyledIntro>
      <QuestionWrapper id={`${name}-form-question`} className="FormQuestion-root">
        <Typography id={`${name}-question`} className="FormQuestion-question">
          {text}
        </Typography>
        {options && options[0] && (
          <Typography id={`${name}-question-description`} className="FormQuestion-description">
            {options[0].text}
          </Typography>
        )}
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleContinue}
          disabled={false}
          style={{ marginTop: '1rem' }}
        >
          {intl.formatMessage({ id: 'common.continue' })}
        </Button>
      </QuestionWrapper>
    </StyledIntro>
  );
};

Intro.propTypes = {
  name: PropTypes.string,
  text: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
};

export default Intro;
